import { render, staticRenderFns } from "./IA3.vue?vue&type=template&id=424b5126&"
import script from "./IA3.vue?vue&type=script&lang=js&"
export * from "./IA3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports